import { createSelector } from '@reduxjs/toolkit';
import { DEFAULT_FONT_FAMILY } from '@ff-os/pdp-shared-redux/apis/fonts/loadFonts';
import { observeStore } from '@ff-os/pdp-shared-redux/observeStore';
import { selectAreFontsReady } from '@ff-os/pdp-shared-redux/slices/fontsSlice';
import { selectAllVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState, GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { updateFontFamilyByIds } from '@gift-variable-plugins/text-pdp/_redux';

export const ensureFontCompatibility = (store: GiftPdpStore) => {
    observeStore(store, selectFontsAndProjectLoaded, (fontsAndProjectLoaded) => {
        if (fontsAndProjectLoaded) {

            const state = store.getState();

            const variables = selectAllVariables(state);
            const inputs = variables
                .filter(v => v.pluginId === 'text')
                .map(v => state.project.inputs.entities[v.id]!);

            const fontFamilies = state.fonts.families.map(f => f.name);
            const textInputsWithIncompatibleFonts = inputs
                .filter(i => !fontFamilies.includes(i.value.fontFamily))
                .map(i => i.id);

            if (textInputsWithIncompatibleFonts.length > 0) {
                store.dispatch(updateFontFamilyByIds(
                    textInputsWithIncompatibleFonts, DEFAULT_FONT_FAMILY.name));
            }
        }
    });
};

const selectFontsAndProjectLoaded = createSelector([
    selectAreFontsReady,
    (state: GiftPdpState) => state.projectLoading.loadStatus === 'ready'
], (fontsReady, projectReady) => fontsReady && projectReady);